'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1Extra2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, profile: state.profile.data };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Extra2, _Component);

  function Module1Extra2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Extra2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Extra2.__proto__ || (0, _getPrototypeOf2.default)(Module1Extra2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Sample meal plan'
    }, _this.convertISOTimeToAge = function () {
      var now = new Date();
      var date = new Date(_this.props.profile.childDOB);
      var yearDiff = now.getFullYear() - date.getFullYear();
      var monthDiff = now.getMonth() - date.getMonth();
      var dayDiff = now.getDay() - date.getDay();

      if (monthDiff < 0) {
        yearDiff--;
      } else if (monthDiff === 0) {
        if (dayDiff < 0) {
          yearDiff--;
        }
      }
      return yearDiff;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module1Extra2, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'This plan provides fruit and vegetables at each meal and snack and meets children\u2019s requirements for fruit and vegetables for their age, according to the Australian Guide to Healthy Eating (AGHE).'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Whilst it provides an appropriate number of serves and a variety of fruit and vegetables, this plan may need to be modified to suit your child\u2019s individual energy requirements (e.g. an active 10 year old boy that plays sport after school may require an additional snack, e.g. a handful of nuts or a slice of toast with cheese, to meet his energy needs).'
          ),
          this.convertISOTimeToAge() < 3 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              ReactBootstrap.Table,
              { striped: true, bordered: true, responsive: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Age group'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '2 - 3 years'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Breakfast'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Porridge with 1/2 banana, sliced (1/2 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Morning tea'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '1/4 cup cucumber sticks with hummus (1/2 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Lunch'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Egg and salad sandwich',
                    _react2.default.createElement('br', null),
                    '1/4 cup grated carrot (1/2 serve)',
                    _react2.default.createElement('br', null),
                    '1/4 cup shredded lettuce'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Afternoon tea'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '10 blueberries with yoghurt (1/2 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Dinner'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Chicken and veggie meatball burgers',
                    _react2.default.createElement('br', null),
                    '1/4 cup carrot (1/2 serve)',
                    _react2.default.createElement('br', null),
                    '1/4 cup capsicum (1/2 serve)',
                    _react2.default.createElement('br', null),
                    '1/4 cup mixed shredded lettuce (1/4 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: '4' },
                    'Total serves and variety'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('td', null),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Veg: 2.5 serves, 4 types',
                    _react2.default.createElement('br', null),
                    'Fruit: 1 serve, 2 types'
                  )
                )
              )
            )
          ),
          this.convertISOTimeToAge() > 3 && this.convertISOTimeToAge() < 9 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              ReactBootstrap.Table,
              { bordered: true, responsive: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Age group'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '4 - 8 years'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Breakfast'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Banana and berry smoothie (1 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Morning tea'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '1/2 cup carrot sticks with hummus (1 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Lunch'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Wholemeal veggie pizzas with tomato, capsicum, broccoli and mushrooms (1 1/2 serves)',
                    _react2.default.createElement('br', null),
                    '1/2 apple, sliced (1/2 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Afternoon tea'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '1/4 cup avocado on a wholegrain cracker (1/2 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Dinner'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Spaghetti Bolognese with hidden veg',
                    _react2.default.createElement('br', null),
                    '1/4 cup grated zucchini (1/2 serve)',
                    _react2.default.createElement('br', null),
                    '1/4 cup grated carrot (1/2 serve)',
                    _react2.default.createElement('br', null),
                    '1/2 chopped tomato (in sauce) (1/2 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: '4' },
                    'Total serves and variety'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('td', null),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Veg: 4.5 serves, 6 types',
                    _react2.default.createElement('br', null),
                    'Fruit: 1.5 serves, 3 types'
                  )
                )
              )
            )
          ),
          this.convertISOTimeToAge() > 8 && this.convertISOTimeToAge() < 12 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              ReactBootstrap.Table,
              { bordered: true, responsive: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Age group'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '2 - 3 years'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '4 - 8 years'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '9 - 11 years'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Breakfast'
                  ),
                  _react2.default.createElement('td', null)
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Morning tea'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '1 mini veggie quiche'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Lunch'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Tuna and salad wrap',
                    _react2.default.createElement('br', null),
                    '1/2 cup leafy greens',
                    _react2.default.createElement('br', null),
                    '1/2 tomato, sliced (1/2 serve)',
                    _react2.default.createElement('br', null),
                    '1/2 cup carrot, grated (1 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Afternoon tea'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '1x medium fruit ',
                    _react2.default.createElement('br', null),
                    'Eg. an apple (1 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Dinner'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Steak and vegetables',
                    _react2.default.createElement('br', null),
                    '1/2 medium sweet potato (1 serve)',
                    _react2.default.createElement('br', null),
                    '1/2 cup broccoli (1 serve)',
                    _react2.default.createElement('br', null),
                    '1/2 cup canned pears in natural juice (1/2 serve)'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: '4' },
                    'Total serves and variety'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('td', null),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Veg: 5 serves, 5 types',
                    _react2.default.createElement('br', null),
                    'Fruit: 2 serves, 3 types'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Module1Extra2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module1Extra2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Extra/Extra2.js
// module id = 1175
// module chunks = 0